/**
 * Social proof activity popup.
 * Vanilla JS, no dependencies. Reads its config from a JSON script tag
 * rendered by sections/social-proof-popup.liquid.
 */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'sp:';
  var LAST_SIGNATURE_KEY = 'spLastSignatureGlobal';

  var MALE_NAMES = [
    'Ahmed', 'Muhammad', 'Ali', 'Bilal', 'Usman', 'Hassan', 'Saad', 'Hamza', 'Umar', 'Abdullah',
    'Zain', 'Talha', 'Fahad', 'Waleed', 'Junaid', 'Kamran', 'Imran', 'Adeel', 'Faisal', 'Asad',
    'Shahzad', 'Rizwan', 'Naveed', 'Tariq', 'Waqas', 'Farhan', 'Salman', 'Danish', 'Haris', 'Shoaib',
    'Arslan', 'Nabeel', 'Ovais', 'Zeeshan', 'Sajid', 'Rashid', 'Aamir', 'Adnan', 'Kashif', 'Owais',
    'Sheraz', 'Yasir', 'Noman', 'Shahbaz', 'Asif', 'Irfan', 'Sarmad', 'Hasnain', 'Moiz', 'Ammar',
    'Mustafa', 'Ibrahim', 'Yousaf', 'Suleman', 'Qasim', 'Awais', 'Sohail', 'Bilawal', 'Fawad', 'Majid'
  ];

  var FEMALE_NAMES = [
    'Ayesha', 'Fatima', 'Zainab', 'Mariam', 'Hina', 'Iqra', 'Sana', 'Rabia', 'Noor', 'Amna',
    'Laiba', 'Sadia', 'Mahnoor', 'Aliza', 'Anum', 'Farah', 'Sidra', 'Nida', 'Saba', 'Komal',
    'Rida', 'Hira', 'Sara', 'Wajeeha', 'Mehak', 'Areeba', 'Bushra', 'Uzma', 'Shazia', 'Farzana',
    'Nazia', 'Samina', 'Sundas', 'Tayyaba', 'Warda', 'Zoya', 'Alishba', 'Eman', 'Fiza', 'Javeria',
    'Kiran', 'Madiha', 'Neha', 'Palwasha', 'Quratulain', 'Rimsha', 'Sabeen', 'Tehmina', 'Ushna', 'Vania',
    'Wardah', 'Yumna', 'Zara', 'Zunaira', 'Aiman', 'Bakhtawar', 'Dua', 'Esha', 'Gul', 'Hafsa'
  ];

  var ALL_NAMES = MALE_NAMES.concat(FEMALE_NAMES);

  var CITIES = [
    'Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar', 'Sialkot',
    'Hyderabad', 'Gujranwala', 'Bahawalpur', 'Sargodha', 'Abbottabad', 'Quetta', 'Sukkur'
  ];

  var TIME_STRINGS = [
    'Just now', '4 minutes ago', '8 minutes ago', '12 minutes ago', '27 minutes ago', '53 minutes ago',
    '1 hour ago', '3 hours ago', '5 hours ago', '7 hours ago', 'Yesterday', '2 days ago', '3 days ago'
  ];

  var DEFAULT_TEMPLATES = [
    '{name} from {city} viewed this recently',
    '{name} from {city} chose our bundle',
    '{name} from {city} ordered {product}',
    '{name} from {city} completed checkout'
  ];

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function sessionGet(key, fallback) {
    try {
      var raw = sessionStorage.getItem(STORAGE_PREFIX + key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function sessionSet(key, value) {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    } catch (e) {}
  }

  function localGet(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function localSet(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function buildContent(products, templates) {
    var lastSignature = sessionGet('lastSignature', null) || localGet(LAST_SIGNATURE_KEY, null);
    var attempts = 0;
    var content;

    do {
      var name = pick(ALL_NAMES);
      var city = pick(CITIES);
      var template = pick(templates.length ? templates : DEFAULT_TEMPLATES);
      var product = products.length ? pick(products) : null;
      var time = pick(TIME_STRINGS);
      var text = template
        .replace('{name}', name)
        .replace('{city}', city)
        .replace('{product}', product ? product.title : 'our product');
      var signature = name + '|' + city + '|' + template;

      content = { text: text, time: time, thumb: product ? product.image : null, signature: signature };
      attempts++;
    } while (content.signature === lastSignature && attempts < 12);

    return content;
  }

  function SocialProofPopup(root) {
    this.root = root;
    this.config = null;
    this.toast = null;
    this.closeBtn = null;
    this.thumbEl = null;
    this.textEl = null;
    this.timeEl = null;
    this.hideTimer = null;
    this.hideAt = null;
    this.remainingOnPause = null;
    this.boundDismiss = this.onDismiss.bind(this);
    this.boundPause = this.pauseHide.bind(this);
    this.boundResume = this.resumeHide.bind(this);
  }

  SocialProofPopup.prototype.init = function () {
    var configEl = this.root.querySelector('[data-sp-config]');
    if (!configEl) return;

    try {
      this.config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    if (!this.config.enabled) return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile && !this.config.enableMobile) return;
    if (!isMobile && !this.config.enableDesktop) return;

    if (sessionGet('dismissed', false)) return;

    this.toast = this.root.querySelector('[data-sp-toast]');
    if (!this.toast) return;

    this.closeBtn = this.toast.querySelector('[data-sp-close]');
    this.thumbEl = this.toast.querySelector('[data-sp-thumb]');
    this.textEl = this.toast.querySelector('[data-sp-text]');
    this.timeEl = this.toast.querySelector('[data-sp-time]');

    if (this.closeBtn) this.closeBtn.addEventListener('click', this.boundDismiss);
    this.toast.addEventListener('mouseenter', this.boundPause);
    this.toast.addEventListener('mouseleave', this.boundResume);

    this.scheduleAll();
  };

  SocialProofPopup.prototype.scheduleAll = function () {
    var config = this.config;

    var sessionStart = sessionGet('start', null);
    if (sessionStart === null) {
      sessionStart = Date.now();
      sessionSet('start', sessionStart);
    }

    var delays = sessionGet('delays', null);
    if (delays === null) {
      delays = [];
      for (var i = 0; i < config.maxPopups; i++) {
        var min, max;
        if (i === 0) {
          min = config.firstDelayMin;
          max = config.firstDelayMax;
        } else {
          min = config.secondDelayMin;
          max = config.secondDelayMax;
        }
        delays.push((min + Math.random() * (max - min)) * 1000);
      }
      sessionSet('delays', delays);
    }

    var elapsed = Date.now() - sessionStart;
    var shownCount = sessionGet('shownCount', 0);

    for (var idx = shownCount; idx < delays.length; idx++) {
      this.scheduleOne(idx, Math.max(0, delays[idx] - elapsed));
    }
  };

  SocialProofPopup.prototype.scheduleOne = function (index, remaining) {
    var self = this;
    setTimeout(function () {
      self.maybeShow(index);
    }, remaining);
  };

  SocialProofPopup.prototype.maybeShow = function (index) {
    if (sessionGet('dismissed', false)) return;

    var shownCount = sessionGet('shownCount', 0);
    if (index < shownCount || shownCount >= this.config.maxPopups) return;

    var content = buildContent(this.config.products, this.config.templates);
    sessionSet('lastSignature', content.signature);
    localSet(LAST_SIGNATURE_KEY, content.signature);
    sessionSet('shownCount', shownCount + 1);

    this.render(content);
  };

  SocialProofPopup.prototype.render = function (content) {
    if (this.textEl) this.textEl.textContent = content.text;
    if (this.timeEl) this.timeEl.textContent = content.time;

    if (this.thumbEl) {
      if (content.thumb) {
        this.thumbEl.src = content.thumb;
        this.thumbEl.hidden = false;
      } else {
        this.thumbEl.hidden = true;
      }
    }

    var toast = this.toast;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    this.hideAt = Date.now() + this.config.displayDuration;
    this.hideTimer = setTimeout(this.hide.bind(this), this.config.displayDuration);
  };

  SocialProofPopup.prototype.hide = function () {
    if (this.toast) this.toast.classList.remove('is-visible');
    this.hideTimer = null;
  };

  SocialProofPopup.prototype.pauseHide = function () {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
      this.remainingOnPause = this.hideAt - Date.now();
    }
  };

  SocialProofPopup.prototype.resumeHide = function () {
    if (this.remainingOnPause !== null && this.remainingOnPause > 0) {
      this.hideTimer = setTimeout(this.hide.bind(this), this.remainingOnPause);
      this.remainingOnPause = null;
    }
  };

  SocialProofPopup.prototype.onDismiss = function () {
    if (this.hideTimer) clearTimeout(this.hideTimer);
    this.hide();
    sessionSet('dismissed', true);
  };

  function bootstrap() {
    var roots = document.querySelectorAll('[data-social-proof-root]');
    roots.forEach(function (root) {
      if (root.dataset.spInit) return;
      root.dataset.spInit = 'true';
      new SocialProofPopup(root).init();
    });
  }

  function excludedPage() {
    var path = window.location.pathname;
    return path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0 || path.indexOf('/orders/') === 0;
  }

  function lazyInit() {
    if (excludedPage()) return;

    if ('requestIdleCallback' in window) {
      requestIdleCallback(bootstrap, { timeout: 2000 });
    } else {
      setTimeout(bootstrap, 200);
    }
  }

  if (document.readyState === 'complete') {
    lazyInit();
  } else {
    window.addEventListener('load', lazyInit);
  }
})();
